module.exports = __webpack_public_path__ + "static/media/logofolio4.eeadf01b.jpg";